import React from "react";
import MoneyInput from "../../UIComponent/MoneyInput";
import NumberInput from "../../UIComponent/NumberInput";

const Row2Input = (props) => {
  return (
    <>
      <div className="grid 2xl:grid-cols-2 lg:grid-cols-2 h-auto  w-full items-center my-8 text-size-18 font-bold">
        <h2 className={props.className}>{props.caption}</h2>


        {props.col1InputType === "Percentage" ? (
          <div className="percentage-input flex items-center">
            <MoneyInput
              placeholder="0"
              name={props.col1FieldName}
              value={props.col1value}
              handleChange={props.handleChange}
              validateField={props.validateField}
              validState={props.validState}
              error={props.error1}
            />
            <div className="ml-5">
              off
            </div>
          </div>
        ) : null}
        {props.col1InputType === "Money" ? (
          <div className="sign-icon-input flex items-center">
            <MoneyInput
              placeholder="0"
              name={props.col1FieldName}
              value={props.col1value}
              handleChange={props.handleChange}
              validateField={props.validateField}
              validState={props.validState}
              error={props.error1}
            />
            <div className="ml-5">
              off
            </div>
          </div>
        ) : null}


        {props.col1InputType === "Number" ? (
          <NumberInput
            placeholder="0"
            name={props.col1FieldName}
            value={props.col1value}
            handleChange={props.handleChange}
            validateField={props.validateField}
            validState={props.validState}
            error={props.error1}
          />
        ) : null}


{props.col2InputType === "Percentage" ? (
          <div className="percentage-input flex items-center">
            <MoneyInput
              placeholder="0"
              name={props.col2FieldName}
              value={props.col2value}
              handleChange={props.handleChange}
              validateField={props.validateField}
              validState={props.validState}
              error={props.error2}
            />
          </div>
        ) : null}

        {props.col2InputType === "Money" ? (
          <div className="sign-icon-input">
            <MoneyInput
              placeholder="0"
              name={props.col2FieldName}
              value={props.col2value}
              handleChange={props.handleChange}
              validateField={props.validateField}
              validState={props.validState}
              error={props.error2}
            />
          </div>
        ) : null}


        {props.col2InputType === "Number" ? (
          <NumberInput
            placeholder="0"
            name={props.col2FieldName}
            value={props.col2value}
            handleChange={props.handleChange}
            validateField={props.validateField}
            validState={props.validState}
            error={props.error2}
          />
        ) : null}
      </div>
    </>
  );
};
export default Row2Input;